import { render } from "./Sidebar.vue?vue&type=template&id=5ee6586e&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import "./Sidebar.vue?vue&type=style&index=0&id=5ee6586e&scoped=true&lang=css"
import "./Sidebar.vue?vue&type=style&index=1&id=5ee6586e&lang=css"
script.render = render
script.__scopeId = "data-v-5ee6586e"

export default script